import { Schema, SchemaSettings } from '@orbit/data'
import { findRemoteIdFromNewRecord, KC } from '@/http/utils'
import moment from 'moment-timezone'

enum ModelTypes {
  MonthlyCosts = 'monthly-cost',
}

enum ModelTypeNames {
  MonthlyCosts = 'monthlyCost',
}

// export interface MonthlyCosts {
//   programName: string
//   programInteractions: number
//   programAvgAdherencePerc: number
//   programPatientsTotal: number
//   programPatientsActive: number
//   programPatientsCompleted: number
// }

export interface GetMonthlyCostsDto {
  startTimestamp: number | undefined
  endTimestamp: number | undefined
}

export interface MonthlyCostsAttributes {
  type: string
  year: number
  month: number
  cost: number
}

export interface MonthlyCostsSchema {
  id: string
  attributes: MonthlyCostsAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.MonthlyCosts]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        type: { type: 'string' },
        year: { type: 'number' },
        month: { type: 'number' },
        cost: { type: 'number' },
      },
    },
  },
}

export async function getMonthlyCostsQuery(params: {
  startTimestamp?: number | undefined
  endTimestamp?: number | undefined
}) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for monthly costs')
      let query = q.findRecords(ModelTypes.MonthlyCosts)
      if (params && params.startTimestamp != null) {
        query = query.filter(
          { attribute: 'starttimestamp', value: params.startTimestamp },
          { attribute: 'endtimestamp', value: params.endTimestamp }
        )
      }
      return query
    })
    .catch(e => {
      console.log('fetch failed for monthly costs')
      console.log(e)
    })
}

// export async function patchSiteQuery(payload) {
//   let p = payload
//   let s = schemaDefinition
//   const schema = new Schema(schemaDefinition)
//   const remote = await KC.getJsonApiRemoteResource(schema)
//   return remote.push(q => {
//     console.log('Before calling update record for monthly costs')
//     return q.addRecord({
//       id: payload.id,
//       type: ModelTypeNames.MonthlyCosts,
//       attributes: payload.attributes,
//     })
//   })
// }

export async function setMonthlyCostsQuery(payload) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResourceForNewRecord(schema)
  const result = await remote.push(q => {
    // let id = payload.attributes.siteName + '-00'
    // payload.attributes.id = id
    console.log('Before calling push record')
    return q.addRecord({
      id: '',
      type: ModelTypeNames.MonthlyCosts,
      attributes: payload.attributes,
    })
  })
  return findRemoteIdFromNewRecord(result)
}
